const AMPLITUDE_USER_PROPERTIES = {
    IQOS_DEVICES_IDS: 'iqos_devices_ids',
    IQOS_DEVICES_MODELS: 'iqos_devices_models',
    MARKET: 'market',
};

export default AMPLITUDE_USER_PROPERTIES;
